import { faCoins } from '@fortawesome/pro-duotone-svg-icons'
import { Stack } from '@mui/material'
import { memo } from 'react'

import Popup from 'src/components/shared/popup/Popup'
import DisplayValue from 'src/components/shared/text/DisplayValue'

const SuccessPopup = ({ onSubmit, onCancel, t, value, type, symbol }) => {
  return (
    <Popup
      title={t(`brand:staking.success-${type}-title`, { symbol })}
      description={t(`brand:staking.success-${type}-desc`, { symbol })}
      submitLabel={t('common.close')}
      onFormSubmit={onSubmit}
      onCancel={onCancel}
      icon={faCoins}
    >
      <Stack spacing={1} sx={{ py: { xs: 1, md: 1 } }}>
        <DisplayValue title={value} />
      </Stack>
    </Popup>
  )
}

export default memo(SuccessPopup)
